import EVENTS from '@shared/events';
import { BaseController } from '@shared/basecontroller.controller';

class ProductwalletController extends BaseController {
  constructor(AppService, ProductWalletStore, PageService, $timeout) {
    'ngInject';

    super(AppService);

    this.ProductWalletStore = ProductWalletStore;
    this.PageService = PageService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.removeSettingsHighlight();
    this.addListener(EVENTS.BET_PROCESSED, event => this.refreshCustomerProducts());
    this.addListener(EVENTS.TRANSACTION_PROCESSED, event => this.refreshCustomerProducts());
  }

  onSuccessfulSubmission() {
    this.PageService.showModal('successModal');
  }

  finishTransaction() {
    this.PageService.goto('overview');
  }

  refreshCustomerProducts() {
    this.broadcast('reload.customer-products');
  }

  removeSettingsHighlight() {
    this.$timeout(() => {
      $('#settings').removeClass('subdrop');
    }, 100);
  }
}

export default ProductwalletController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/productwallet/productwallet.controller.js